import { __ } from '@/utils/utils'

import type { RouteRecordRaw } from 'vue-router'

export const termsRoutes: RouteRecordRaw = {
  path: '/:lang?/terms',
  props: (route) => ({ lang: route.params.lang || 'en' }),
  component: () => import('@/Terms/layouts/DefaultLayout.vue'),
  children: [
    {
      path: '',
      name: 'terms-overview',
      component: () => import('@/Terms/views/HantecPolicies.vue'),
      meta: { breadcrumbLabel: __('Terms'), breadcrumbRoute: 'terms' }
    },
    {
      path: 'hantec-policies/',
      name: 'hantec-policies',
      component: () => import('@/Terms/views/HantecPolicies.vue'),
      meta: { breadcrumbLabel: __('Hantec Policies') }
    }
  ]
}
